/* eslint no-underscore-dangle: 0 */

import Rx from "rxjs/Rx";

import calculatorValueSelected$ from "../office-floor-space-calculator";
import { calculatorTabSelected$, rowsTabSelected$ } from "./tab-switcher.component";
import { allSearchTypeFiltersDisabled$ } from "./type-filters-panel.component";

const calculatorValueUpdatedSource = new Rx.Subject();
/**
 * no args
 */
export const calculatorValueUpdated$ = calculatorValueUpdatedSource.asObservable();

export class CalculatorComponent {
    /**
     * @param {Object} node - Jquery node. Unique for every CalculatorComponent class instance.
     */
    constructor(node) {
        this.node = node;
        this._calculatorValue = null;
        this.subscribeOnCalculatorTabSelected();
        this.subscribeOnRowsTabSelected();
        this.subscribeOnAllTypeFiltersDisabled();

        this.initialize();
    }

    initialize() {
        this.subscribeOnCalculatorValueSelected$();
    }

    subscribeOnCalculatorTabSelected() {
        calculatorTabSelected$.subscribe(() => {
            this.setActiveVisualState();
        });
    }

    subscribeOnRowsTabSelected() {
        rowsTabSelected$.subscribe(() => {
            this.setPassiveVisualState();
        });
    }

    subscribeOnAllTypeFiltersDisabled() {
        allSearchTypeFiltersDisabled$.subscribe(() => {
            this.setPassiveVisualState();
        });
    }

    get calculatorValue() {
        if (this._calculatorValue && !this._calculatorValue.max) {
            return null;
        }
        return this._calculatorValue;
    }

    subscribeOnCalculatorValueSelected$() {
        calculatorValueSelected$.subscribe((calculatorValue) => {
            this._calculatorValue = calculatorValue;
            calculatorValueUpdatedSource.next();
        });
    }

    setActiveVisualState() {
        this.node.addClass("active");
    }

    setPassiveVisualState() {
        this.node.removeClass("active");
    }
}
